// resolver-loader.provider.ts
import { inject, makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { RESOLVER_LOADER_CONFIG, ResolverLoaderConfig } from '@constants/resolver-loader.config';
import { ResolverLoaderService } from '@services/resolver-loader.service';

export function provideResolverLoader(
	config: Partial<ResolverLoaderConfig> = {}
): EnvironmentProviders {
	return makeEnvironmentProviders([
		{ provide: RESOLVER_LOADER_CONFIG, useValue: config },
		provideAppInitializer(() => {
			// Istanzia il servizio e aggancia i listener al Router
			inject(ResolverLoaderService);
			// opzionale: puoi restituire una Promise se ti serve attendere qualcosa
		}),
	]);
}
